import React, { useEffect, useState } from 'react';
import { Link, NavLink, Redirect } from "react-router-dom";
import { Button, Header, Icon, Image, Menu, Modal, Popup } from 'semantic-ui-react';
import { fetchVtype } from '../vtype/data/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { requestLogout } from '../login/data/action';
import { fetchSegmapList, fetchCostCategory, fetchCostCenter } from '../common/data/actions';

import PrivateRoute from './privateRoute';
import DownloadData from '../downloaddata/index';
import ItemMap from '../itemmap/index';
import LedgerMap from '../ledgermap/index';
import ReportsDownloadForm from '../reports/components/downloadReports';
import UploadXlsxForm from '../reports/components/uploadXlsx';
import Segmap from '../segmap/index';
import Test from '../test/index';
import OldSyncPullForm from '../txnsync/components/oldSyncPullForm';
import TxnSync from '../txnsync/index';
import UploadData from '../uploaddata/index';
import LogUpload from '../log-upload/index';
import Uploader from '../uploader/index';
import Vtype from '../vtype/index';
import ArchiveData from '../archivedata/index';
import MarutiSync from '../marutisync/index';
import VtParamMap from '../vtparammap';
import VinWiseOpening from '../vinWiseOpening/index';
import logo from "./logo1.png";
import './menu.css';


const TaskMenu = (props) => {
    const dateNow = new Date();
    const [isLogout, setIsLogout] = useState(false)
    const successfulLogout = useSelector(state => state.login.params.successfulLogout)
    const token = successfulLogout ? null : localStorage.getItem('user')
    const isValid = successfulLogout ? false : (localStorage.getItem('exp') > dateNow.getTime() / 1000)
    const menu_permission = localStorage.getItem('menu_permission')
    const dispatch = useDispatch()

    useEffect(() => {
        if (token && isValid) {
            dispatch(fetchVtype())
            dispatch(fetchSegmapList())
            dispatch(fetchCostCategory())
            dispatch(fetchCostCenter())
        }
    }, [token, isValid]);


    useEffect(() => {
        const timeout = setTimeout(() => {
            setIsLogout(true)
        }, ((parseInt(localStorage.getItem('exp')) - parseInt((dateNow.getTime() / 1000) + 30)) * 1000))
        return () => clearTimeout(timeout)
    }, [])

    const continueToLogin = () => {
        setIsLogout(false)
        dispatch(requestLogout());
    }

    if (!token || !isValid) {
        console.log("logged in");
        return (
            <Redirect
                to={{
                    pathname: "/login",
                    // state: { from: location }
                }}
            />
        )
    } else {

        // const dispatch = useDispatch()
        const logout = () => {
            dispatch(requestLogout());
        }
        return (
            <div style={{ padding: '0 50px 0 ' }} id="mainContainer">
                <Menu id="mainMenu" borderless>
                    <Menu.Item as={Link} to="/" className="logo-item">
                        <Image src={logo} />
                    </Menu.Item>
                    {(menu_permission.toLowerCase().trim() === "" || menu_permission.toLowerCase().trim().includes("segment_map")) ?
                        <Popup content='Segment Map' position='bottom center' className='menu-tooltip' trigger={
                            <Menu.Item as={NavLink} to="/segmap/list" activeClassName="active">
                                <Icon name='list' />
                            </Menu.Item>
                        } />
                        : null}
                    {(menu_permission.toLowerCase().trim() === "" || menu_permission.toLowerCase().trim().includes("vin_wise_opp_map")) ?
                        <Popup content='Vin Wise Opening' position='bottom center' className='menu-tooltip' trigger={
                            <Menu.Item as={NavLink} to="/vin_wise_opp/list" activeClassName="active">
                                <Icon name='vine' />
                            </Menu.Item>
                        } />
                        : null}
                    {(menu_permission.toLowerCase().trim() === "" || menu_permission.toLowerCase().trim().includes("vtype_map")) ?
                        <Popup content='Vtype Map' position='bottom center' className='menu-tooltip' trigger={
                            <Menu.Item as={NavLink} to="/vtype/list" activeClassName="active">
                                <Icon name='vimeo' />
                            </Menu.Item>
                        } />
                        : null}
                    {(menu_permission.toLowerCase().trim() === "" || menu_permission.toLowerCase().trim().includes("ledger_map")) ?
                        <Popup content='Ledger Map' position='bottom center' className='menu-tooltip' trigger={
                            <Menu.Item as={NavLink} to="/ledgermap/list" activeClassName="active">
                                <Icon name='paste' />
                            </Menu.Item>
                        } />
                        : null}
                    {(menu_permission.toLowerCase().trim() === "" || menu_permission.toLowerCase().trim().includes("item_map")) ?
                        <Popup content='Item Map' position='bottom center' className='menu-tooltip' trigger={
                            <Menu.Item as={NavLink} to="/itemmap/list" activeClassName="active">
                                <Icon name='steam' />
                            </Menu.Item>
                        } />
                        : null}

                    {/* Maruti  - JOB-120985 - Need Vtparam Mapping in UI/Front end */}
                    {(menu_permission.toLowerCase().trim() === "" || menu_permission.toLowerCase().trim().includes("vtparam_map")) ?
                        <Popup content='VtParam Map' position='bottom center' className='menu-tooltip' trigger={
                            <Menu.Item as={NavLink} to="/vtparam_map/list" activeClassName="active">
                                <Icon name='list alternate' />
                            </Menu.Item>
                        } />
                        : null}
                    {(menu_permission.toLowerCase().trim() === "" || menu_permission.toLowerCase().trim().includes("dms_txn_sync")) ?
                        <Popup content='DMS Txn Sync' position='bottom center' className='menu-tooltip' trigger={
                            <Menu.Item as={NavLink} to="/txnsync/list" activeClassName="active">
                                <Icon name='car' />
                            </Menu.Item>
                        } />
                        : null}
                    {(menu_permission.toLowerCase().trim() === "" || menu_permission.toLowerCase().trim().includes("download_data")) ?
                        <Popup content='Download Data' position='bottom center' className='menu-tooltip' trigger={
                            <Menu.Item as={NavLink} to="/downloaddata" activeClassName="active">
                                <Icon name='download' />
                            </Menu.Item>
                        } />
                        : null}
                    {(menu_permission.toLowerCase().trim() === "" || menu_permission.toLowerCase().trim().includes("upload_json_data")) ?
                        <Popup content='Upload Data' position='bottom center' className='menu-tooltip' trigger={
                            <Menu.Item as={NavLink} to="/uploaddata" activeClassName="active">
                                <Icon name='upload' />
                            </Menu.Item>
                        } />
                        : null}
                    {(menu_permission.toLowerCase().trim() === "" || menu_permission.toLowerCase().trim().includes("upload_log_data")) ?
                        <Popup content='Upload LOG Data' position='bottom center' className='menu-tooltip' trigger={
                            <Menu.Item as={NavLink} to="/log-upload" activeClassName="active">
                                <Icon name='cloud upload' />
                            </Menu.Item>
                        } />
                        : null}
                    {(menu_permission.toLowerCase().trim() === "" || menu_permission.toLowerCase().trim().includes("uploader")) ?
                        <Popup content='Uploader' position='bottom center' className='menu-tooltip' trigger={
                            <Menu.Item as={NavLink} to="/uploader" activeClassName="active">
                                <Icon name='file excel' />
                            </Menu.Item>
                        } />
                        : null}
                    {(menu_permission.toLowerCase().trim() === "" || menu_permission.toLowerCase().trim().includes("download_reports")) ?
                        <Popup content='Reports Download' position='bottom center' className='menu-tooltip' trigger={
                            <Menu.Item as={NavLink} to="/download-reports" activeClassName="active">
                                <Icon name='file alternate' />
                            </Menu.Item>
                        } />
                        : null}
                    {(menu_permission.toLowerCase().trim() === "" || menu_permission.toLowerCase().trim().includes("archiving_data")) ?
                        <Popup content='Archiving Data Download' position='bottom center' className='menu-tooltip' trigger={
                            <Menu.Item as={NavLink} to="/download-archive/list" activeClassName="active">
                                <Icon name='archive' />
                            </Menu.Item>
                        } />
                        : null}
                    <Menu.Menu position='right'>
                        <div className='menu-divider' />
                        <Popup content='LOGOUT' position='bottom right' className='menu-tooltip' trigger={
                            <Menu.Item as={Link} to="/" onClick={logout} className='logout-item'>
                                <Icon name='power off' />
                            </Menu.Item>
                        } />
                    </Menu.Menu>
                </Menu>


                <div className="padding_20">
                    <PrivateRoute path="/segmap" component={Segmap} />
                    <PrivateRoute path="/ledgermap" component={LedgerMap} />
                    <PrivateRoute path="/itemmap" component={ItemMap} />
                    <PrivateRoute path="/vtparam_map" component={VtParamMap} />
                    <PrivateRoute path="/txnsync" component={TxnSync} />
                    <PrivateRoute path="/marutisync" component={MarutiSync} />
                    <PrivateRoute path="/downloaddata" component={DownloadData} />
                    <PrivateRoute path="/download-reports" component={ReportsDownloadForm} />
                    <PrivateRoute path="/uploaddata" component={UploadData} />
                    <PrivateRoute path="/log-upload" component={LogUpload} />
                    <PrivateRoute path="/uploader" component={Uploader} />
                    <PrivateRoute path="/test" component={Test} />
                    <PrivateRoute path="/upload-xlsx" component={UploadXlsxForm} />
                    <PrivateRoute path="/vtype" component={Vtype} />
                    <PrivateRoute path="/oldsync" component={OldSyncPullForm} />
                    <PrivateRoute path="/download-archive/list" component={ArchiveData} />
                    <PrivateRoute path="/vin_wise_opp" component={VinWiseOpening} />
                </div>
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={true}
                />
                <Modal open={isLogout} size="mini">
                    <Modal.Header>Session Status</Modal.Header>
                    <Modal.Content>
                        <Header as='h4'>Your session is Logged out continue to Login</Header>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button type="button" basic color='green' onClick={() => continueToLogin()}>Continue</Button>
                    </Modal.Actions>
                </Modal>
            </div>

        )
    }

}

export default TaskMenu;